import type { SearchImportsItem } from 'Types/beRecipientsApi'

export interface TableState {
  loading: boolean
  items: SearchImportsItem[]
  totalItems: number
  pageSize: number
  pageNumber: number
  orderBy: string
  orderDescending: boolean
  isInit: boolean
}

export interface SelectionState {
  mode: 'all' | 'selection'
  checked: number[]
  unchecked: number[] //  future
}

export interface ModalDelesteImpostsState {
  show: boolean
  title: string
  descr: string
  id: number
  source: string
}

export interface ModalClauseImportState {
  show: boolean
}

export interface ImportStatus {
  status: 'stop' | 'running' | 'error' | ''
}

export const EXTRA_COLUMN_BEFORE_WIDTH = '15px'
export const EXTRA_COLUMN_AFTER_WIDTH = '26px'
